import { render, staticRenderFns } from "./OrdenesCompraCRUDV1.vue?vue&type=template&id=7882e9b6"
import script from "./OrdenesCompraCRUDV1.vue?vue&type=script&lang=js"
export * from "./OrdenesCompraCRUDV1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports